import React from "react";
import "./index.scss";
import App from "./App";
import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { OpenUrl } from "./services/sso";
import * as signalR from "@microsoft/signalr";
import { LogLevel } from "@microsoft/signalr";
import { MachineTranslationResponse } from "./connector/models/apiModels";
import { fileActions } from "./reducers/file.slice";
import { generateShowErrorAction } from "./reducers/control.slice";
import { BrowserRouter } from "react-router-dom";

// @ts-ignore fix this later
import { gtag, install, initDataLayer } from "ga-gtag";
import { initSentry } from "./services/sentry";



const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
initDataLayer();
gtag("config", "GA_MEASUREMENT_ID", {
  linker: {
    domains: ["checkout.stripe.com"],
  },
  
});
gtag("consent", "default", {
  ad_storage: "denied",
  ad_user_data: "denied", 
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
  security_storage: "granted",
  wait_for_update: 2000,
});
gtag("set", "ads_data_redaction", true);
gtag("set", "url_passthrough", true);
install("G-KHS5LY95VQ");

//TODO: check how to use it

export const hubConnection = new signalR.HubConnectionBuilder().configureLogging(LogLevel.Error).withUrl("https://api.textunited.com/docprocessor/MachineTranslationStatusHub").withAutomaticReconnect().build();
hubConnection.on("MachineTranslationDone", (message: MachineTranslationResponse) => {
  if (message.machineTranslationStatusName == "Done") {
    store.dispatch(fileActions.changeTranslationStatus(true));
    store.dispatch(fileActions.loading(false));
  } else {
    store.dispatch(generateShowErrorAction({ show: true, action: "serverError" }));
  }
});
//OpenUrl("https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=" + process.env.REACT_APP_SSO_URL + "&checkOnly=Y");
OpenUrl("https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=" + document.location.href + "&checkOnly=Y");

initSentry();

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <StrictMode>
        <App />
      </StrictMode>
    </BrowserRouter>
  </Provider>
);
